import { SidePanelDS, TextCapitalized, Spacer } from "@qivia/ui";
import EcoDrivingScoreDetails from "@qivia/ui/src/designSystem/components/EcoDrivingScoreDetails";
import { useTranslation } from "react-i18next";
import { DriversListType } from "../driversAPI";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";

export const EcoDrivingScoreSection = (props: {
  driver: DriversListType;
  hasAdvancedAnalytics: boolean;
}) => {
  const { t } = useTranslation();

  if (!props.hasAdvancedAnalytics || !props.driver.ecoDrivingScore) return;

  return (
    <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
      <StyledTitle>
        <TextCapitalized>
          {t("drivers.sidePanel.ecoDrivingScore.title")}
        </TextCapitalized>
      </StyledTitle>
      <Spacer y={1.5} />
      <EcoDrivingScoreDetails
        scores={props.driver.ecoDrivingScore}
        drivingEvents={props.driver.drivingEvents}
      />
    </SidePanelDS.Section>
  );
};

const StyledTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]}
`;
